/** The lengths the mobile sheet offers, so a gift costs the same on both. */
export const GIFT_MONTH_OPTIONS = [1, 3, 6, 12];

/**
 * Months of the artist's monthly fee, rounded to the eight decimal places SIKI
 * amounts are stored at so the total never carries a floating-point tail.
 */
export function giftTotal(monthlyFee, months) {
  const fee = Number(monthlyFee);
  const count = Number(months);
  if (!Number.isFinite(fee) || !Number.isFinite(count)) return 0;
  return Math.round(fee * count * 1e8) / 1e8;
}

export default giftTotal;
